<template>
	<!-- 抽奖结果 -->
	<div class="lottery-results">
		<img src="https://image.soole.com.cn/202012191124.png" alt="">
		<div class="box">
			<!-- 查询 -->
			<div class="search">
				<div>
					<van-cell-group>
					  <van-field v-model="userId" placeholder="请输入搜了宝用户ID" />
					</van-cell-group>
				</div>
				<div @click="searchAward">搜索</div>
			</div>
			<!-- 中奖列表 -->
			<div class="list">
				<div class="list-tit">
					<div>一等奖中奖名单</div>
					<div>赠长虹65寸智能电视机</div>
				</div>
				
				<div class="ls">
					<div>【 中奖名单 】</div>
					<div class="scroll">
						<div>
							<div v-for="(item,index) in one" :key="item">ID:{{item}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="list">
				<div class="list-tit">
					<div>二等奖中奖名单</div>
					<div>赠豪华创业电动车</div>
				</div>
				
				<div class="ls">
					<div>【 中奖名单 】</div>
					<div class="scroll">
						<div>
							<div v-for="(item,index) in two" :key="item">ID:{{item}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="list">
				<div class="list-tit">
					<div>三等奖中奖名单</div>
					<div>赠搜了宝创业手机</div>
				</div>
				
				<div class="ls">
					<div>【 中奖名单 】</div>
					<div class="scroll">
						<div>
							<div v-for="(item,index) in three" :key="item">ID:{{item}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="list">
				<div class="list-tit">
					<div>幸运奖中奖名单</div>
					<div>赠美的电饭锅</div>
				</div>
				
				<div class="ls">
					<div>【 中奖名单 】</div>
					<div class="scroll">
						<div>
							<div v-for="(item,index) in four" :key="item">ID:{{item}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { Toast } from 'vant';
	export default {
		name: '',
		data() {
			return {
				list:[],
				content:'',
				url:'',
				page:0,
				rows:20,
				access_token:'',
				userId:'',
				baseURL:'',
				one:[],
				two:[],
				three:[],
				four:[],
			};
		},
		created() {
			 this.getList();
		},
		mounted() {
			document.querySelector('body').setAttribute('style', 'background-color:#F8F8F8');
			document.querySelector('title').innerText = '中奖查询';
		},
		methods: {
			async searchAward(url,mediaId){
				if(this.userId===""){
					Toast("输入的ID不能为空！");
					return;
				}
				this.getList(this.userId);
				
			},
			async getList(userId=''){
				Toast.loading({ message: '加载中...',forbidClick: true,loadingType: 'spinner'});
				let res = await this.$axios.get(`/api/common/v1/meeting/winPrizeLog?pageNum=1&pageSize=10000&platForm=app&userId=${userId}`);
				if(res.data.success){
					Toast.clear();
					console.log('get',res.data.data);
					let list = res.data.data.list;
					if(userId){
						let obj = {userId:userId};
						if(list.length!==0){
							obj = {...list[0],...obj};
						}
						console.log('obj',obj);
						this.$router.push({path:"/award",query:{obj}})
					}else{
						// 一等奖
						// 二等奖
						// 三等奖、
						let one = [];
						let two = [];
						let three = [];
						let four = [];
						list.forEach(item=>{
							switch (item.prize_grade){
								case 1:
									one.push(item.user_id)
									break;
								case 2:
									two.push(item.user_id)
									break;
								case 3:
									three.push(item.user_id)
									break;
								case 4:
									four.push(item.user_id)
									break;
								default:
									break;
							}
						});
						this.one = one;
						this.two = two;
						this.three = three;
						this.four = four;
					}
					
				}else{
					Toast(res.data.msg);
					Toast.clear();
				}
			},
			dateInit(d){
				return this.$util.dateFormat(new Date(Number(d+'000')),"yyyy-MM-dd hh:mm:ss");
			}
		}
	};
</script>

<style lang="less" scoped>
	.lottery-results{
		// background: url(https://image.soole.com.cn/2020130903.png) no-repeat;
		// background-size: 100%;
		// height: 100vh;
		// width: 100%;
		img{
			width: 100%;
		}
		position: relative;
		.box{
			position: absolute;
			top: 290px;
			left: 0px;
			right: 0px;
		}
		.search{
			display: flex;
			align-items: center;
			padding: 0 1.25rem;
			margin-bottom: 2.25rem;
			&>div:nth-child(1){flex: 1;}
			&>div:nth-child(2){
				height: 24px;
				line-height: 24px;
				font-size: 16px;
				flex-shrink: 0;
				padding: 4px 0.6375rem;
				background-color: #EDCBAD;
				color: #FFFFFF;
			}
			.van-cell{padding: 4px 10px;}
		}
		.list{
			margin-top: 2rem;
		}
		.list-tit{
			color: #CA3433;
			width: 9.75rem;
			height: 3.375rem;
			padding: 0.625rem 0.3125rem;
			margin: auto;
			text-align: center;
			box-sizing: border-box;
			background: url(https://image.soole.com.cn/2020130901.png) no-repeat;
			background-size: 100% 100%;
			border-radius: 0.4125rem;
			margin-top: 0.9375rem;
			&>div:nth-child(1){
				font-size: 1.25rem;
				font-weight: 700;
			}
			&>div:nth-child(2){
				font-size: 0.75rem;
				margin-top: 0.125rem;
			}
		}
		.ls{
			background: url(https://image.soole.com.cn/2020130902.png) no-repeat;
			background-size: 100% 100%;
			width: 22.6875rem;
			height: 14.625rem;
			margin: auto;
			position: relative;
			&>div:nth-child(1){
				color: #C92419;
				font-size: 1.3125rem;
				font-weight: 700;
				position: absolute;
				top: 2.5rem;
				width: 100%;
				text-align: center;
			}
			&>div:nth-child(2){
				height: 100px;
				overflow-y: scroll;
				position: absolute;
				top: 5.3rem;
				margin: 0 2rem;
				color: #B3662E;
				
				&>div{
					display: flex;
					flex-wrap: wrap;
					font-size: 1.0625rem;
					div{
						margin:0 0.9rem 0.6rem;
						flex-shrink: 0;
						flex: 1;
					}
				}
			}
			
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/annualMeeting/lottery-results.vue